import React from 'react';

import { NumericFormat } from 'react-number-format';
import { TEXT_COLOR_AZUL_OSCURO } from '../../styles/Styles';

const NumberFormatCustom = (props) => {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        value: values.value,
                    },
                });
            }}
            thousandSeparator="."
            decimalSeparator=","
            //evitar signo negativo -
            allowNegative={false}
            //evitar punto decimal "." desde el teclado
            decimalScale={0}
            prefix="Gs. "
            style={{
                textAlign: 'center',
                fontSize: '30px',
                fontWeight: 'bold',
                color: TEXT_COLOR_AZUL_OSCURO,
                borderRadius: '14px',
            }}

        />

    );
}

export default NumberFormatCustom;
